module.exports = __webpack_public_path__ + "static/media/grid-item-a13.dbbfb542.png";